<div class="fixed inset-0 bg-gray-700/75 backdrop-blur-sm flex justify-center items-center z-50 no-scrollbar"
  (click)="onClose()">
  <div (click)="$event.stopPropagation()"
    class="bg-white shadow-2xl rounded-2xl p-6 max-w-md w-full relative border border-blueGray-100 flex flex-col">

    <!-- Header: Title + Close X -->
    <div class="flex flex-row justify-between items-center mb-2">
      <div>
        <h1 class="font-bold text-xl text-blueGray-800">{{ title }}</h1>
        <p class="text-xs text-blueGray-400 mt-1">Registered Volunteers</p>
      </div>
      <button type="button" (click)="onClose()" class="text-blueGray-400 hover:text-blueGray-600 focus:outline-none">
        <i class="fas fa-xmark text-xl"></i>
      </button>
    </div>

    <!-- Volunteers List -->
    <div class="my-4 max-h-[300px] overflow-y-auto pr-1">
      @if (volunteers.length === 0) {
      <div class="flex flex-col items-center justify-center py-8 text-center">
        <i class="fa fa-hand-holding-heart text-4xl text-blueGray-200 mb-3"></i>
        <p class="text-sm font-semibold text-blueGray-500">No volunteers registered yet.</p>
        <p class="text-xs text-blueGray-400 mt-1">Slots: 0 / {{ volunteersRequired }}</p>
      </div>
      } @else {
      <div class="flex flex-col gap-3">
        @for (volunteer of volunteers; track volunteer.uid) {
        <div class="flex items-center justify-between border border-blueGray-200 rounded-lg p-2">
          <div class="flex items-center gap-3">
            @if (volunteer.photoUrl) {
            <img [src]="volunteer.photoUrl" alt="Avatar"
              class="w-10 h-10 rounded-full object-cover border border-blueGray-200">
            } @else {
            <div
              class="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-bold text-sm">
              {{ getInitials(volunteer.name) }}
            </div>
            }
            <div class="flex flex-col">
              <span class="font-semibold text-sm text-blueGray-800">{{ volunteer.name }}</span>
              <span class="text-[10px] text-blueGray-400">
                Volunteered {{ volunteer.date | moment: 'MMM DD, h:mm a' }}
              </span>
            </div>
          </div>

          <!-- Delete Button -->
          <button type="button" (click)="deleteVolunteer(volunteer)" [disabled]="deletingMap[volunteer.uid]"
            class="w-8 h-8 rounded-lg hover:bg-red-50 text-blueGray-400 hover:text-red-600 flex items-center justify-center transition-all disabled:opacity-50 focus:outline-none"
            title="Remove volunteer">
            @if (deletingMap[volunteer.uid]) {
            <i class="fa fa-spinner fa-spin text-sm"></i>
            } @else {
            <i class="fa-regular fa-trash-can text-sm"></i>
            }
          </button>
        </div>
        }
      </div>
      }
    </div>

    <!-- Footer / Stats -->
    <div class="mt-6 pt-4 border-t border-blueGray-100 flex justify-between items-center">
      <span class="text-xs font-semibold text-emerald-600">
        Filled: {{ volunteers.length }} / {{ volunteersRequired }} slots
      </span>
      <button type="button" (click)="onClose()"
        class="bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white font-bold uppercase text-xs px-6 py-2.5 rounded-lg shadow-sm hover:shadow focus:outline-none transition-all duration-150">
        Close
      </button>
    </div>

  </div>
</div>